import React from "react";

import { ProtectedRoute } from "../common/components/ProtectedRoute";
import { RouteProps } from "react-router-dom";
import { StoreState } from "common/store/types";
import { User } from "common/store/user/types";
import { useSelector } from "react-redux";

export enum ProtectionType {
  UserKnown,
  UserVerified,
}

interface Props extends RouteProps {
  component: any;
  reverseLogic: boolean;
  protection?: ProtectionType;
}

export const UserInfoProtectedRoute: React.FC<Props> = ({
  component: Component,
  reverseLogic,
  protection = ProtectionType.UserKnown,
  ...rest
}) => {
  const auth = useSelector<StoreState, boolean>((state) => state.token !== "");

  const storageUserDetails = useSelector<StoreState, User>(
    (state) => state.currentUser
  );

  let push = false;
  let redirectRoute = "/authentication/login";
  let accessCondition = auth === true;
  if (accessCondition) {
    let userCondition = true;
    let userRedirectRoute = "";
    switch (protection) {
      case ProtectionType.UserKnown: {
        const userKnown = storageUserDetails.userKnown();

        if (reverseLogic) {
          userCondition = !userKnown;
          userRedirectRoute = "/personal-data";
        } else {
          userCondition = userKnown;
          userRedirectRoute = "/kyc";
          push = true;
        }

        break;
      }
      case ProtectionType.UserVerified: {
        userCondition = storageUserDetails.userVerified();

        const userKnown = storageUserDetails.userKnown();
        if (userKnown) {
          userRedirectRoute = "/idnowstatus";
        } else {
          userRedirectRoute = "/kyc";
          push = true;
        }

        break;
      }
      default:
        break;
    }

    redirectRoute = userRedirectRoute;
    accessCondition = userCondition;
  }

  return (
    <ProtectedRoute
      component={Component}
      redirectRoute={redirectRoute}
      accessCondition={accessCondition}
      push={push}
      {...rest}
    />
  );
};
